var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 16.933 16.933",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.1289.52917h8.253v2.9518h-5.6055v2.4093c.25296-.08342.50592-.14602.75889-.18775.25871-.04879.52605-.07297.80202-.07297 1.5695 0 2.7912.4763 3.6651 1.4289.87386.94567 1.3108 2.2669 1.3108 3.9636-1e-5 1.6828-.47719 3.0005-1.4315 3.9531-.94862.95263-2.2681 1.429-3.9583 1.429-.73016 0-1.4546-.08689-2.1732-.26075-.7129-.16687-1.4229-.42415-2.1301-.77182v-3.1604c.7014.48675 1.3654.85183 1.9921 1.0952.63241.24339 1.2275.36507 1.7851.36507.80488 0 1.4373-.2364 1.8972-.7093.46567-.47974.69852-1.1264.69853-1.94-1.1e-5-.82053-.23286-1.4672-.69853-1.94-.45994-.47286-1.0924-.7093-1.8972-.7093-.47718 0-.98599.07647-1.5264.22945-.54043.14605-1.1211.3755-1.742.68842v-8.7615",
    fill: "#f00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.c3f314461956b6ccb01077a0deffd9a2.svg";
export { ForwardRef as ReactComponent };